import {
  ACTIVITY_ICON_NAME,
  LESSON_ACTIVITY_TYPE,
} from "@plugins/common/constant/resource.constant.ts";

export default {
  methods: {
    getActivityIconName(activity) {
      return this.getActivityIconNameByTypeAndOptional(activity.type, activity.optional);
    },
    getActivityIconNameByTypeAndOptional(type, optional) {
      if (type === LESSON_ACTIVITY_TYPE.ACTIVITY_QUIZ) {
        return optional ? ACTIVITY_ICON_NAME.QUIZ_OPTIONAL : ACTIVITY_ICON_NAME.QUIZ_PAGE;
      } else {
        return optional ? ACTIVITY_ICON_NAME.PAGE_OPTIONAL : ACTIVITY_ICON_NAME.PAGE;
      }
    },
    getActivityCompletedDisabledIconName(activity) {
      if (activity.type === LESSON_ACTIVITY_TYPE.ACTIVITY_QUIZ) {
        return activity.optional
          ? ACTIVITY_ICON_NAME.QUIZ_COMPLETED_DISABLED_OPTIONAL
          : ACTIVITY_ICON_NAME.QUIZ_COMPLETED_DISABLED;
      } else {
        return activity.optional
          ? ACTIVITY_ICON_NAME.PAGE_COMPLETED_DISABLED_OPTIONAL
          : ACTIVITY_ICON_NAME.PAGE_COMPLETED_DISABLED;
      }
    },
    getActivityCompletedIconName(activity) {
      if (activity.type === LESSON_ACTIVITY_TYPE.ACTIVITY_QUIZ) {
        return ACTIVITY_ICON_NAME.QUIZ_COMPLETED;
      } else {
        return ACTIVITY_ICON_NAME.PAGE_COMPLETED;
      }
    },
    getActivityNoAccessIconName(activity) {
      if (activity.type === LESSON_ACTIVITY_TYPE.ACTIVITY_QUIZ) {
        return ACTIVITY_ICON_NAME.QUIZ_NO_ACCESS;
      } else {
        return ACTIVITY_ICON_NAME.PAGE_NO_ACCESS;
      }
    },
    getActivityRestrictedIconName(activity) {
      if (activity.type === LESSON_ACTIVITY_TYPE.ACTIVITY_QUIZ) {
        return ACTIVITY_ICON_NAME.QUIZ_RESTRICTED;
      } else {
        return ACTIVITY_ICON_NAME.PAGE_RESTRICTED;
      }
    },
    getActivityPrerequisiteIconName(activity) {
      if (activity.type === LESSON_ACTIVITY_TYPE.ACTIVITY_QUIZ) {
        return ACTIVITY_ICON_NAME.QUIZ_PAGE_PREREQ;
      } else {
        return ACTIVITY_ICON_NAME.PAGE_PREREQ;
      }
    },
    getActivityOptionalIconName(activity) {
      if (activity.type === LESSON_ACTIVITY_TYPE.ACTIVITY_QUIZ) {
        return ACTIVITY_ICON_NAME.QUIZ_OPTIONAL;
      } else {
        return ACTIVITY_ICON_NAME.PAGE_OPTIONAL;
      }
    },
  },
};
